import { Link } from 'react-router-dom';
import './single-internal-banner.scss';

export const SingleInternalBanner = ({
    page,
    author,
    categories
}) => {
    const decodeHTML = (html) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || '';
    }

    const formatDate = (v) => {
        const today = new Date(v);
        const month = today.getMonth() + 1;
        const formattedMonth = month < 10 ? `0${month}` : `${month}`;
        const day = today.getDate();
        const formattedDay = day < 10 ? `0${day}` : `${day}`;
        const year = today.getFullYear();
        const formattedDate = `${formattedMonth}-${formattedDay}-${year}`;
        
        return formattedDate;
    }
    return <section id='single-internal-banner'>
        <div className="container">
            <div className="banner-area">
                <h1>{ decodeHTML(page?.post_title) ?? 'Undefined Title' }</h1>
                <div className='blog-meta-wrapper'>
                    <div className='blog-meta'>
                        <span className='author'>By <strong>{author?.data?.display_name}</strong></span>
                        <span className='date'>Updated: <strong>{formatDate(page?.post_modified ?? page?.post_date)}</strong></span>
                    </div>
                    {
                        categories?.length > 0 && <ul>

                            {categories?.map((it, index) => <li key={index}>
                                <Link to={ `/legal-blog/category/${it?.slug}`}>{it?.cat_name}</Link>
                            </li>)}
                        </ul>
                    }
                </div>
            </div>
        </div>
    </section>
}